import { createSlice } from "@reduxjs/toolkit";
const searchMetadataSlice = createSlice({
  name: "searchMetadata",
  initialState: {
    isLoading: false,
    metadata: void 0
  },
  reducers: {
    loading: (state) => ({
      ...state,
      isLoading: true,
      metadata: void 0
    }),
    finishedLoading: (state, action) => ({
      ...state,
      isLoading: false,
      metadata: action.payload
    })
  }
});
const { finishedLoading, loading } = searchMetadataSlice.actions;
export const searchMetadataSliceReducer = searchMetadataSlice.reducer;
export const parseSearch = (search, parse) => async (dispatch) => {
  dispatch(loading());
  return parse(search).then((result) => dispatch(finishedLoading(result)));
};
